/**
 * Public Saferpay configuration values
 */
export class TenantSettingsPublicIntegrationsSaferpayDto {
  isApiUsernameConfigured?: boolean | null;
  isApiPasswordConfigured?: boolean | null;
  isCustomerIdConfigured?: boolean | null;
  isTerminalIdConfigured?: boolean | null;
  isSecurePayGateTerminalIdConfigured?: boolean | null;
}
